export function redirectToLogin(): void {
  window.location.href = '/';
}

export class ApiError extends Error {
  status: number;
  code?: string;
  data: Record<string, unknown>;

  constructor(message: string, status: number, data: Record<string, unknown> = {}) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = typeof data.code === 'string' ? data.code : undefined;
    this.data = data;
  }
}

export async function apiFetch(url: string, options: RequestInit = {}): Promise<any> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(options.headers as Record<string, string> || {}),
  };
  const response = await fetch(url, { ...options, headers, credentials: 'same-origin' });

  if (response.status === 401) {
    redirectToLogin();
    throw new Error('Session expired');
  }

  let data: Record<string, any> = {};
  if (response.status !== 204) {
    const contentType = response.headers.get('content-type') || '';
    const normalizedContentType = contentType.toLowerCase();
    if (!normalizedContentType.includes('application/json') && !normalizedContentType.includes('+json')) {
      throw new ApiError('Operations API returned an invalid response', response.status || 502, {
        code: 'INVALID_API_RESPONSE',
      });
    }

    try {
      data = await response.json();
    } catch {
      throw new ApiError('Operations API returned invalid JSON', response.status || 502, {
        code: 'INVALID_API_RESPONSE',
      });
    }
  }

  if (!response.ok) {
    const message = data.detail || data.error || data.message || 'Request failed';
    throw new ApiError(message, response.status, data);
  }
  return data;
}
